export enum enumStripePaymentError {
  CARD_ERROR = 'card_error',
  VALIDATION_ERROR = 'validation_error',
}
